<template>
    <v-app>
        <Navbar />
        <v-content class="mx-8 my-8">
            <router-view></router-view>
        </v-content>

        <!-- global dialog -->
        <v-dialog v-model="this.$store.state.appProgressDialog" persistent width="300">
            <v-card color="primary" dark>
                <v-card-text>
                    {{ this.$store.state.appProgressMessage }}
                    <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-app>
</template>

<script>
import Navbar from "@/components/Navbar";

export default {
    name: "App",

    components: {
        Navbar
    },

    data: () => ({
        timeout: 3000
    })
};
</script>

<style>
  /* .something {
    color: var(--v-primary-base);
    background-color: var(--v-accent-lighten2);
  } */
  /* .v-content {
      background: #dfdfdf !important;
  }
  .v-application--wrap {
      background: #dfdfdf !important;
  } */
</style>